import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SendTimeExtensionIcon from "@mui/icons-material/SendTimeExtension";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import TitleIcon from "@mui/icons-material/Title";
import MessageIcon from "@mui/icons-material/Message";

import React, { useState, useEffect, useCallback, useContext } from "react";
import { useSnackbar } from "notistack";
import {
  Box,
  CircularProgress,
  Typography,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  getKumesler,
  getUyariDonemleri,
  getUyariListesi,
  getUyariDetaylari,
  getMesajDetayi,
} from "../services/api";
import { AuthContext } from "../context/AuthContext";

const formatDateForInput = (date) => {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
};

const themeColor = "#F97316";
const themeColorDark = "#EA580C";
const themeColorLight = "#ef6c00";
const themeColorText = "white";

const SistemUyarilari = () => {
  // ✅ Kullanıcı bilgilerini al
  const { kullaniciId, kullanici } = useContext(AuthContext);

  // ✅ Console'a kullanıcı ID yazdır
  useEffect(() => {
    //console.log("🔍 SistemUyarilari - Kullanıcı ID:", kullaniciId);
    // console.log("🔍 SistemUyarilari - Kullanıcı:", kullanici);
  }, [kullaniciId, kullanici]);

  const [uyariListesi, setUyariListesi] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [kumesler, setKumesler] = useState([]);
  const [donemler, setDonemler] = useState([]);
  const [selectedKumes, setSelectedKumes] = useState("");
  const [selectedDonem, setSelectedDonem] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return formatDateForInput(date);
  });
  const [endDate, setEndDate] = useState(formatDateForInput(new Date()));

  const [detayModalOpen, setDetayModalOpen] = useState(false);
  const [mesajModalOpen, setMesajModalOpen] = useState(false);
  const [seciliUyariDetaylari, setSeciliUyariDetaylari] = useState([]);
  const [seciliMesaj, setSeciliMesaj] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    const fetchKumesler = async () => {
      try {
        const response = await getKumesler();
        const kumesData = response.data.data || [];
        setKumesler(kumesData);
        if (kumesData.length > 0) {
          setSelectedKumes(kumesData[0].KUMES_ID);
        }
      } catch (err) {
        enqueueSnackbar("Kümes listesi alınamadı: " + err.message, {
          variant: "error",
        });
      }
    };
    fetchKumesler();
  }, [enqueueSnackbar]);

  useEffect(() => {
    if (selectedKumes) {
      const fetchDonemler = async () => {
        setDonemler([]);
        setSelectedDonem("");
        try {
          const response = await getUyariDonemleri(selectedKumes);
          const donemData = response.data.data || response.data.Data || [];
          setDonemler(donemData);
          if (donemData.length > 0) {
            setSelectedDonem(donemData[0].DONEM_ID);
          }
        } catch (err) {
          enqueueSnackbar("Dönemler alınamadı: " + err.message, {
            variant: "error",
          });
        }
      };
      fetchDonemler();
    }
  }, [selectedKumes, enqueueSnackbar]);

  const handleListele = useCallback(async () => {
    if (!selectedKumes || !selectedDonem) return;
    setLoading(true);
    try {
      const data = {};

      // console.log("📡 Filter data (with user ID):", filterData);

      const response = await getUyariListesi({
        kullaniciId: 81,
        cihazTokenId: "FD763FD1-6008-4E19-ACAC-5F8F9D97C3CB-1761639093397",
      });
      const uyariData = response.data.data || response.data.Data || [];

      // ✅ Duplicate key kontrolü ve unique ID ekleme
      // console.log("🔍 Raw uyari data:", uyariData);

      const processedData = uyariData.map((item, index) => ({
        ...item,
        _uniqueKey: `${item.DONEM_UYARI_ID || "no-id"}-${index}-${Date.now()}`,
      }));

      setUyariListesi(processedData);
    } catch (err) {
      enqueueSnackbar(`Uyarılar alınamadı: ${err.message}`, {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [
    selectedKumes,
    selectedDonem,
    startDate,
    endDate,
    kullaniciId,
    enqueueSnackbar,
  ]); // ← kullaniciId dependency eklendi

  useEffect(() => {
    if (selectedKumes && selectedDonem) {
      handleListele();
    }
  }, [selectedDonem, handleListele]);

  const handleDetayClick = async (uyariId) => {
    if (!uyariId) {
      enqueueSnackbar("Detayları getirmek için geçerli bir ID bulunamadı.", {
        variant: "error",
      });
      return;
    }
    setModalLoading(true);
    setDetayModalOpen(true);
    try {
      const response = await getUyariDetaylari(uyariId);
      const detayData = response.data.data || response.data.Data || [];

      // ✅ Detay verilerine de unique key ekle
      const processedDetayData = detayData.map((item, index) => ({
        ...item,
        _detayUniqueKey: `detay-${
          item.DONEM_UYARI_BIL_ID || "no-id"
        }-${index}-${Date.now()}`,
      }));

      setSeciliUyariDetaylari(processedDetayData);
    } catch (error) {
      enqueueSnackbar("Uyarı detayları alınamadı: " + error.message, {
        variant: "error",
      });
      setDetayModalOpen(false);
    } finally {
      setModalLoading(false);
    }
  };
  //

  const handleMesajClick = async (mesajId) => {
    if (!mesajId) return;
    setModalLoading(true);
    setMesajModalOpen(true);
    try {
      const response = await getMesajDetayi(mesajId);
      const messageData =
        (response.data.data && response.data.data[0]) ||
        (response.data.Data && response.data.Data[0]) ||
        null;
      setSeciliMesaj(messageData);
    } catch (error) {
      enqueueSnackbar("Mesaj detayı alınamadı: " + error.message, {
        variant: "error",
      });
      setMesajModalOpen(false);
    } finally {
      setModalLoading(false);
    }
  };

  const formFocusStyles = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: themeColor,
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: themeColor,
    },
  };

  return (
    <>
      <Paper sx={{ p: 2, mt: 2, display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" gutterBottom>
          {" "}
          Sistem Uyarıları Raporu
          {kullanici?.AD && (
            <Typography
              variant="caption"
              sx={{ ml: 2, color: "text.secondary" }}
            >
              ({kullanici.AD} {kullanici.SOYAD})
            </Typography>
          )}{" "}
        </Typography>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          {/* Grid item prop'ları eklendi ve focus stilleri uygulandı */}
          <Grid item xs={12} sm={6} md={2.5}>
            <FormControl fullWidth size="small" sx={formFocusStyles}>
              <InputLabel>Kümes</InputLabel>
              <Select
                value={selectedKumes}
                label="Kümes"
                onChange={(e) => setSelectedKumes(e.target.value)}
              >
                {Array.isArray(kumesler) &&
                  kumesler.map((k) => (
                    <MenuItem key={k.KUMES_ID} value={k.KUMES_ID}>
                      {k.KUMES_ADI}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2.5}>
            <FormControl
              fullWidth
              size="small"
              disabled={!selectedKumes}
              sx={formFocusStyles}
            >
              <InputLabel>Dönem</InputLabel>
              <Select
                value={selectedDonem}
                label="Dönem"
                onChange={(e) => setSelectedDonem(e.target.value)}
              >
                {Array.isArray(donemler) &&
                  donemler.map((d) => (
                    <MenuItem key={d.DONEM_ID} value={d.DONEM_ID}>
                      {d.KUMES_DONEM_ADI}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Başlangıç Tarihi"
              type="date"
              size="small"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={formFocusStyles}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Bitiş Tarihi"
              type="date"
              size="small"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={formFocusStyles}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleListele}
              disabled={loading}
              sx={{
                backgroundColor: themeColor,
                "&:hover": { backgroundColor: themeColorDark },
              }}
            >
              Listele
            </Button>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              {/* Tablo başlığı renklendirildi */}
              <TableRow sx={{ backgroundColor: themeColorLight }}>
                <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                  Uyarılar
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                  Tarih
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: themeColorText }}
                  align="center"
                >
                  İşlem
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress sx={{ color: themeColor }} />
                  </TableCell>
                </TableRow>
              ) : Array.isArray(uyariListesi) && uyariListesi.length > 0 ? (
                uyariListesi.map((uyari, index) => (
                  <TableRow
                    key={
                      uyari._uniqueKey ||
                      `fallback-${uyari.DONEM_UYARI_ID || index}`
                    } // ← Unique key
                    hover
                  >
                    <TableCell>{uyari.UYARILAR}</TableCell>
                    <TableCell>{uyari.TARIH_STR}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleDetayClick(uyari.DONEM_UYARI_ID)}
                        disabled={!uyari.DONEM_UYARI_ID}
                        sx={{
                          backgroundColor: themeColor,
                          "&:hover": { backgroundColor: themeColorDark },
                        }}
                      >
                        Detay
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    Görüntülenecek uyarı bulunamadı.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Uyarı Detayları Modalı */}
      <Dialog
        open={detayModalOpen}
        onClose={() => setDetayModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Uyarı Detayları
          <IconButton
            onClick={() => setDetayModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {modalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress sx={{ color: themeColor }} />
            </Box>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: themeColorLight }}>
                  <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                    Tarih
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                    Tel No
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                    Bildirim Metni
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: themeColorText }}>
                    Mesaj Detayı
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(seciliUyariDetaylari) &&
                  seciliUyariDetaylari.map((detay) => (
                    <TableRow
                      key={
                        detay._detayUniqueKey ||
                        `fallback-detay-${detay.DONEM_UYARI_BIL_ID}`
                      } // ← Processed unique key
                    >
                      <TableCell>{detay.TARIH_STR}</TableCell>
                      <TableCell>{detay.TEL_NO}</TableCell>
                      <TableCell>{detay.BILDIRIM_METNI}</TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          onClick={() =>
                            handleMesajClick(detay.DONEM_UYARI_BIL_ID)
                          }
                          sx={{ color: themeColor }}
                        >
                          Mesaj
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDetayModalOpen(false)}
            sx={{ color: themeColor }}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODERN MESAJ DETAYI MODALI */}
      <Dialog
        open={mesajModalOpen}
        onClose={() => setMesajModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <MessageIcon sx={{ color: themeColor }} />
          Mesaj Detayı
          <IconButton
            onClick={() => setMesajModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {modalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress sx={{ color: themeColor }} />
            </Box>
          ) : (
            seciliMesaj && (
              <Grid container spacing={2} sx={{ p: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CalendarTodayIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Bildirim Zamanı
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ pl: 4 }}>
                    {seciliMesaj.TARIH_STR || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CheckCircleOutlineIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Bildirim Durumu
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ pl: 4 }}>
                    {seciliMesaj.BILDIRIM_ADI || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PhoneIphoneIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Kullanıcı Telefon No
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ pl: 4 }}>
                    {seciliMesaj.TEL_NO || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <SendTimeExtensionIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Gönderim Zamanı
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ pl: 4 }}>
                    {seciliMesaj.GONDERIM_ZAMAN_STR || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <MarkEmailReadIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Ulaşma Durumu
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ pl: 4 }}>
                    {seciliMesaj.ULASMA_ZAMAN_STR || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    <TitleIcon fontSize="small" color="action" />
                    <Typography variant="caption" color="text.secondary">
                      Mesaj Başlığı
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ pl: 4, fontWeight: "bold" }}
                  >
                    {seciliMesaj.MESAJ_BASLIK || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      mt: 1,
                      backgroundColor: themeColorLight,
                      borderColor: "rgba(0, 0, 0, 0.12)",
                    }}
                  >
                    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                      {seciliMesaj.BILDIRIM_METNI || "İçerik bulunamadı."}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setMesajModalOpen(false)}
            sx={{ color: themeColor }}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SistemUyarilari;
